// @ts-expect-error incompatibility with node16 resolution
import {Transition} from '@headlessui/react';
import {Fragment, useState} from 'react';
import clsx from 'clsx';
import {Link} from '@shopify/hydrogen';
import {SanityLink, SanityNavigationDropdown} from '../../types';
import getLocale from '../../hooks/getLocale';
import {ChevronDownIcon} from '../icons/ChevronDown';

type Props = {
  closeParent: void;
  dropdown: SanityNavigationDropdown[];
};

export default function MobileNavigationDropdown({
  closeParent,
  dropdown,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
    document?.body.classList.remove('dropdown-open');
  };
  const handleOpen = () => {
    setIsOpen(true);
    document?.body.classList.add('dropdown-open');
  };

  const handleToggle = () => {
    isOpen ? handleClose() : handleOpen();
  };

  return (
    <div className="relative flex flex-col items-start overflow-hidden">
      {/* Title */}
      <div className={'z-10 w-full bg-menu'}>
        <button className={clsx(isOpen ? 'active' : '')} onClick={handleToggle}>
          <div className="h2 flex items-center space-x-3 font-industry">
            <span className="mr-2">
              {/* @ts-ignore */}
              {typeof dropdown.title === 'object'
                ? // @ts-ignore
                  getLocale(dropdown.title)
                : // @ts-ignore
                  dropdown.title}
            </span>
            <ChevronDownIcon className={clsx('w-8', isOpen && 'rotate-180')} />
          </div>
        </button>
      </div>
      <Transition show={isOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={'py-6'}>
            <div className={clsx('container w-full')}>
              <div className="grid grid-cols-1 gap-6">
                {/* @ts-ignore */}
                {dropdown.columns &&
                  // @ts-ignore
                  dropdown.columns?.map((column, index) => (
                    <div key={column._key}>
                      {column?.links?.length > 0 && (
                        <ul className={'h3 font-industry'}>
                          {column.links.map((link: SanityLink) => {
                            return (
                              link?.url && (
                                <li key={link._key}>
                                  <Link
                                    to={link.url}
                                    // @ts-ignore
                                    onClick={closeParent}
                                    className={clsx(
                                      'hover:underline',
                                      link.header ? 'font-bold' : '',
                                    )}
                                  >
                                    {link.linkTitle &&
                                    typeof link.linkTitle === 'object'
                                      ? getLocale(link.linkTitle)
                                      : link.title}
                                  </Link>
                                </li>
                              )
                            );
                          })}
                        </ul>
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </Transition.Child>
      </Transition>
    </div>
  );
}
